import slugify from "./slugify"
import { EditorialType, NodeTypeName, TitleTree } from '../domain/domain';
import { findSubTreeByNodeId } from "../components/ComponentManagementPage/utils";

export function isEnablePrintOption(nodeType: NodeTypeName): boolean {
    return [
        NodeTypeName.TITLE,
        NodeTypeName.DIVISION,
        NodeTypeName.DIVISION_PART,
        NodeTypeName.ARTICLE,
        NodeTypeName.ARTICLE_PART,
        NodeTypeName.ARTICLE_SUBPART,
        NodeTypeName.SECTION,
        NodeTypeName.SUBSECTION,
        NodeTypeName.PARAGRAPH,
        NodeTypeName.SUBPARAGRAPH,
        NodeTypeName.SUB_SUBPARAGRAPH
    ].includes(nodeType);
}

export function stripTags(s: string): string {
    if (!s) {
        return s;
    }
    let ret = s.replace(/<[^>]*>?/gm, '');
    return ret;
}

export function stripTagsPreserveEm(s: string): string {
    if (!s) {
        return s;
    }
    const emOpen = s.replace(/<em>/gi, 'emOpen');
    const emClose = emOpen.replace(/<\/em>/gi, 'emClose');
    const stripped = emClose.replace(/<[^>]*>?/gm, '');
    const restored = stripped.replace(/emOpen/g, '<em>').replace(/emClose/g, '</em>');
    return restored;
}

export function isCanDeleteNode(nodeType: string): boolean {
    if (nodeType === "TITLE") {
        return false;
    }
    return true;
}

export function isCanRepealNode(nodeType: string): boolean {
    return true;
}

export function canHaveChildNodeOfType(parentNodeType: string, childNodeType: NodeTypeName, currentNodeType?: NodeTypeName): boolean {
    if (
        [
            NodeTypeName.TITLE,
            NodeTypeName.DIVISION,
            NodeTypeName.DIVISION_PART
        ].includes(parentNodeType as NodeTypeName) &&
        (
            (
                childNodeType === NodeTypeName.ARTICLE &&
                currentNodeType === undefined
            ) ||
            currentNodeType === NodeTypeName.ARTICLE
        )
    ) {
        return ["ARTICLE"].includes(childNodeType);
    }

    if (parentNodeType === NodeTypeName.ARTICLE) {
        if (currentNodeType === NodeTypeName.ARTICLE_PART || currentNodeType === NodeTypeName.SECTION) {
            return currentNodeType === childNodeType;
        }
        return ["SECTION"].includes(childNodeType);
    }
    if (parentNodeType === NodeTypeName.ARTICLE_PART) {
        if ([NodeTypeName.SECTION, NodeTypeName.ARTICLE_SUBPART].includes(currentNodeType as NodeTypeName)) {
            return currentNodeType === childNodeType;
        }

        return ["SECTION"].includes(childNodeType);
    }
    if (parentNodeType === NodeTypeName.ARTICLE_SUBPART) {
        return ["SECTION"].includes(childNodeType);
    }
    if (parentNodeType === NodeTypeName.SECTION) {
        return ["SUBSECTION"].includes(childNodeType);
    }
    if (parentNodeType === NodeTypeName.SUBSECTION) {
        return ["PARAGRAPH"].includes(childNodeType);
    }
    if (parentNodeType === NodeTypeName.PARAGRAPH) {
        return ["SUBPARAGRAPH"].includes(childNodeType);
    }
    if (parentNodeType === NodeTypeName.SUBPARAGRAPH) {
        return ["SUB_SUBPARAGRAPH"].includes(childNodeType);
    }
    return false;
}

export function getEditorialContentTypeName(editorialType: EditorialType): string {
    if(editorialType === EditorialType.ANALYSIS) {
        return "Analysis";
    }
    if (editorialType === EditorialType.SOURCE_NOTE) {
        return "Source Note";
    }
    if (editorialType === EditorialType.EDITORS_NOTE) {
        return "Editor's Note";
    }
    if (editorialType === EditorialType.CROSS_REFERENCES) {
        return "Cross References";
    }
    if (editorialType === EditorialType.COMMENT) {
        return "Comment";
    }
    if (editorialType === EditorialType.ANNOTATION) {
        return "Annotation";
    }
    if (editorialType === EditorialType.FORM_INDEX) {
        return "Form Index";
    }
    if (editorialType === EditorialType.INDEX) {
        return "Index";
    }
    if (editorialType === EditorialType.ANALYSIS_COMMENT) {
        return "Analysis Comment";
    }
    if (editorialType === EditorialType.INLINE_EDITOR) {
        return "Inline Editor";
    }

    return editorialType;
}

export function findAllowedEditorialTypesForNodeType(nodeType: string): EditorialType[] {
    if (nodeType === "TITLE" || nodeType === "DIVISION" || nodeType === "DIVISION_PART" || nodeType === "ARTICLE" || nodeType === "ARTICLE_PART" || nodeType === "ARTICLE_SUBPART" || nodeType === "SECTION" || nodeType === "SUBSECTION" || nodeType === "PARAGRAPH" || nodeType === "SUBPARAGRAPH" || nodeType === "SUB_SUBPARAGRAPH") {
        return [EditorialType.ANALYSIS, EditorialType.SOURCE_NOTE, EditorialType.EDITORS_NOTE, EditorialType.CROSS_REFERENCES, EditorialType.COMMENT, EditorialType.ANNOTATION, EditorialType.FORM_INDEX, EditorialType.INDEX, EditorialType.ANALYSIS_COMMENT];
    }
    return [];
}

export function removeLastSlash(text: string): string {
    if (!text) {
        return text;
    }
    if (text.endsWith('\\')) {
        return text.substring(0, text.length - 1);
    }
    return text;
}


export function buildComponentPageURL(treeRoot: TitleTree, subTree: TitleTree, editorialType: EditorialType, history: any) {
    let current : (TitleTree | undefined) = subTree;
    while(current!.nodeType !== NodeTypeName.TITLE){
        current = findSubTreeByNodeId(treeRoot!, current!.parentId);
    }
    history.push(`/component/${current?.citation}/?node=${subTree?.nodeId}&editorial_type=${editorialType}`);
}

export function trimString(s: string): string {
    if (!s) {
        return s;
    }
    return s.trim();
}

export { slugify }
